<mat-toolbar class="mat-elevation-z4" color="primary">
  <button mat-icon-button (click)="appService.toggleMainNavigationOpened()" title="Toggle Navigation">
    <mat-icon class="md-24">menu</mat-icon>
  </button>
  <span class="title">{{ title }}</span>
  <button mat-icon-button [matMenuTriggerFor]="appMenu" class="user">
    <mat-icon>person</mat-icon>
  </button>
  <mat-menu #appMenu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item (click)="authService.logout()">
      <mat-icon>power_settings_new</mat-icon>
      Logout
    </button>
  </mat-menu>
</mat-toolbar>
